import React from "react";
import Navigation from "../partials/Navigation";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import {Helmet} from "react-helmet";
import CoursePage from "../partials/Courses/CoursePage";

const StudentGuide = () => {

    return (
        <div className="main-wrapper">

            <Helmet>
				<title>Lärarhandledning F-3</title>
				<meta name="description" content="" />
			</Helmet>

            <Navigation />

            <div className="page-content-wrap">
                <HorizontalNav title="Lärarhandledning F-3" />

                <div className="pt-5 pb-5 pb-lg-6 pt-lg-0 page-content-inner position-relative">
                    <CoursePage courseid="29812" slug="lararhandledning-f-3" />
                </div>
            </div>
        </div>
    )
}

export default StudentGuide;